import { ClientPostStatus, ClientStatus } from "../types/status";
import { StatusResource } from "../resources/status-resource";

export const StatusRepository = {
  async fetchStatus(): Promise<ClientStatus> {
    return await StatusResource.getStatus();
  },

  async postStatus(status: ClientPostStatus): Promise<void> {
    await StatusResource.postStatus(status);
  },
};
